import { Anchor, Box, Group, Text } from "@mantine/core";
import { Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import classes from "./WhatsNew.module.css";

export function WhatsNew() {
    const { t } = useTranslation();
    const { auth } = usePage().props;
    const { user, changelogUnseenCount = 0 } = auth ?? {};

    // The badge is per-user, so there is nothing to show a visitor on the
    // public changelog page. The count itself is resolved server-side, against
    // the same ordering the page renders in.
    if (!user) {
        return null;
    }

    return (
        <Group gap={10} wrap="nowrap">
            <Anchor
                component={Link}
                href={route('studio.changelog')}
                underline="never"
                c="light-dark(var(--mantine-color-figma-grey-7), var(--sma-color-white))"
                className={classes.link}
            >
                <span className={classes.label}>
                    {t('changelog.whatsNew')}
                    {changelogUnseenCount > 0 && (
                        <Text span bg="smartico-pink.6" c="white" className={classes.badge}>
                            {changelogUnseenCount}
                        </Text>
                    )}
                </span>
            </Anchor>
            <Box bg="figma-grey.2" visibleFrom="sm" className={classes.divider} />
        </Group>
    );
}
